import React, { useEffect, useState} from "react"
import Header from "../../../components/navigation/Header"
import axios from "axios"
import CreateCSFR from "../../../hooks/userAuthentication/CreateCSFR"
import { useNavigate } from "react-router-dom"

export default function RefreshStripeOnboarding(){
    const csrfToken = CreateCSFR({ name: "csrftoken" })
    const [displayMessage, setDisplayMessage] = useState("")
    const navigate = useNavigate()
    
    useEffect(()=>{
        document.title = "Refresh Stripe Onboarding Process"

        axios.get(`${process.env.REACT_APP_SKILLJA_URL}/stripe/refresh_stripe_onboarding/`, { 
            headers: {
                'X-CSRFToken': csrfToken,
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
        .then(res => {
            if (res.data.stripeOnboardingLink) {
                window.location.replace(res.data.stripeOnboardingLink)
            }
            else {
                setDisplayMessage("Error! Please contact support@skillja.ca")
            }
        })
        .catch(error => {
            if (error.response) {
                // the server responded with a status code that falls out of the range of 2xx
                console.error('Error response:', error.response.data)
                console.error('Status:', error.response.status)
                console.error('Headers:', error.response.headers)
            } else if (error.request) {
                // no response was received
                console.error('No response received:', error.request)
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error('Error setting up request:', error.message)
            }
            console.error('Error config:', error.config)
        })
    },[])

    return (
        <div className="flex flex-col">
            <Header useCase="onboarding" />
            <section className="pt-40">
                <div className="flex flex-col justify-center items-center text-center">
                    <p className="text-xl font-semibold mx-auto px-4 text-center">
                        Oops! Let's get you back to the onboarding process!
                    </p>
                    <p className="text-base font-semibold mx-auto px-4 mt-4 text-center">
                        Hold on we'll redirect you in a moment...
                    </p>
                    {displayMessage && 
                        <div className="flex flex-col justify-center">
                            <p className="mt-4 text-red-500 px-4 text-center">{displayMessage && displayMessage}</p>
                            <button
                                onClick={()=>navigate('/')}
                                className="form-btn mt-4 px-6"
                                aria-label="redirects to landing page"
                            >
                                Home
                            </button>
                        </div>
                    }
                </div>
            </section>
        </div>
    )
}